import { render, staticRenderFns } from "./PdvDesktopAuthLayout.vue?vue&type=template&id=0f8319ca&scoped=true"
import script from "./PdvDesktopAuthLayout.vue?vue&type=script&lang=js"
export * from "./PdvDesktopAuthLayout.vue?vue&type=script&lang=js"
import style0 from "./PdvDesktopAuthLayout.vue?vue&type=style&index=0&id=0f8319ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8319ca",
  null
  
)

export default component.exports